/**
 * 사용자 프로필 관련 타입 정의
 * 
 * users 테이블: id, provider, email, name, picture, created_at, updated_at
 * user_extend 테이블: user_id, birth_date, gender, phone_number, created_at, updated_at
 */

// 기본 사용자 정보 (users 테이블)
export interface UserBasicInfo {
  id: string;
  provider: 'google' | 'kakao' | 'naver';
  email: string;
  name: string; // nickname
  picture: string | null; // 썸네일 URL
  created_at: string;
  updated_at: string;
}

// 확장 사용자 정보 (user_extend 테이블)
export interface UserExtendInfo {
  birth_date: string | null; // YYYY-MM-DD
  gender: 'M' | 'F' | 'N' | null; // M(남), F(여), N(무응답)
  phone_number: string | null;
  height: number | null; // cm
  created_at: string;
  updated_at: string;
}

// 전체 사용자 프로필 정보 (통합)
export interface UserProfile extends UserBasicInfo, UserExtendInfo {
  profileComplete?: boolean; // 프로필 완성도 (필수 필드 모두 입력됨)
}

// 사용자 프로필 수정 요청 데이터
export interface UpdateUserProfileRequest {
  name?: string; // 닉네임 수정
  birth_date?: string | null; // 생년월일 (YYYY-MM-DD)
  gender?: 'M' | 'F' | 'N' | null; // 성별
  phone_number?: string | null; // 연락처
  height?: number | null; // 신장 (cm)
}

// 사용자 프로필 조회 API 응답
export interface GetUserProfileResponse {
  success: boolean;
  user: UserProfile;
}

// 사용자 프로필 수정 API 응답
export interface UpdateUserProfileResponse {
  success: boolean;
  message: string;
  user: UserProfile;
}

// 성별 옵션
export const GENDER_OPTIONS = {
  M: '남성',
  F: '여성',
  N: '무응답',
} as const;

// 성별 값 배열
export const GENDER_VALUES = Object.keys(GENDER_OPTIONS) as Array<keyof typeof GENDER_OPTIONS>;
